<template>
  <div>
    <!-- Leaderboard Section -->
    <section class="h-auto leaderboard-bg">
      <div class="flex justify-center px-0 lg:pt-[6rem]">
        <div
          class="flex flex-col items-center justify-center p-8 px-0 pt-0 mt-8 lg:mt-0 mb-14 lg:mb-16 rounded-3xl"
          id="leaderboard"
        >
          <!-- ROOBET (COMMENTED OUT FOR FUTURE USE) -->
          <!-- <div
            v-show="selectedLeaderboard == 'roobet'"
            class="flex flex-row items-center justify-center"
          >
            <img
              v-motion-pop-visible
              src="../assets/leaderboard-title.png"
              class="max-h-[100px] lg:max-h-[120px] xl:max-h-[150px] h-full w-auto"
              alt="leaderboard"
            />
            <a href="https://roobet.com/?ref=romieinc" class="self-end" target="_blank"
              ><img
                v-motion-pop-visible
                src="../assets/RomieIncXRoobetLogo.png"
                class="hidden md:block md:max-w-[350px] xl:max-w-[400px] w-full h-auto"
                alt="logo"
            /></a>
          </div> -->

          <!-- STAKE -->
          <div v-show="selectedLeaderboard == 'stake'">
            <div
              class="flex flex-col items-center justify-center gap-3 md:gap-4 mb-10"
            >
              <a href="https://stake.com/?c=romieinc" target="_blank">
                <div class="bg-black rounded-xl px-6 py-3">
                  <img
                    v-motion-pop-visible
                    src="https://stake.com/_app/immutable/assets/stake-full.B38fTPet.svg"
                    class="w-[160px] sm:w-[200px] md:w-[250px] lg:w-[300px] h-auto"
                    alt="stake-logo"
                  />
                </div>
              </a>
              <h1
                class="text-[14px] sm:text-[18px] md:text-[24px] lg:text-[30px] font-bold tracking-[0.25em] md:tracking-[0.3em] text-transparent bg-clip-text bg-gradient-to-r from-[#FFFFFF] via-[#FF7373] to-[#FF0000]"
                style="
                  font-family: 'Stalinist One', sans-serif;
                  text-shadow: 0 0 20px rgba(255, 0, 0, 0.3);
                "
              >
                LEADERBOARD
              </h1>
            </div>
            <div
              v-if="!isPaused"
              class="relative flex flex-col items-center justify-center mt-4 md:mt-6 mb-4 px-4 md:px-8 z-10"
            >
              <h2
                class="text-[20px] sm:text-[30px] md:text-[50px] lg:text-[70px] xl:text-[70px] font-bold leading-none text-transparent bg-clip-text bg-gradient-to-r from-[#FFD700] via-[#FFF8DC] to-[#FFD700] px-2"
                style="
                  font-family: 'Stalinist One', sans-serif;
                  text-shadow: 0 0 40px rgba(255, 215, 0, 0.5);
                "
              >
                ${{
                  animatedRewardAmount.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </h2>
              <p
                class="text-[11px] sm:text-[16px] md:text-[20px] lg:text-[28px] xl:text-[32px] font-semibold tracking-[0.2em] md:tracking-[0.3em] text-white mt-1 md:mt-2"
                style="font-family: 'Stalinist One', sans-serif"
              >
                REWARD
              </p>
            </div>
          </div>

          <!-- STAKE ENGINE -->
          <div v-show="selectedLeaderboard == 'stakeonly'">
            <div
              class="flex flex-col items-center justify-center gap-3 md:gap-4 mb-10"
            >
              <a href="https://stake.com/?c=romieinc" target="_blank">
                <div class="bg-black rounded-xl px-6 py-3">
                  <img
                    v-motion-pop-visible
                    src="https://stake.com/_app/immutable/assets/stake-full.B38fTPet.svg"
                    class="w-[160px] sm:w-[200px] md:w-[250px] lg:w-[300px] h-auto"
                    alt="stake-engine-logo"
                  />
                  <p
                    class="mt-2 text-center text-white text-[12px] sm:text-[14px] md:text-[18px] lg:text-[20px] font-bold tracking-[0.3em]"
                    style="font-family: 'Stalinist One', sans-serif"
                  >
                    ENGINE
                  </p>
                </div>
              </a>
              <h1
                class="text-[14px] sm:text-[18px] md:text-[24px] lg:text-[30px] font-bold tracking-[0.25em] md:tracking-[0.3em] text-transparent bg-clip-text bg-gradient-to-r from-[#FFFFFF] via-[#FF7373] to-[#FF0000]"
                style="
                  font-family: 'Stalinist One', sans-serif;
                  text-shadow: 0 0 20px rgba(255, 0, 0, 0.3);
                "
              >
                LEADERBOARD
              </h1>
            </div>
            <div
              v-if="!isPaused"
              class="relative flex flex-col items-center justify-center mt-4 md:mt-6 mb-4 px-4 md:px-8 z-10"
            >
              <h2
                class="text-[20px] sm:text-[30px] md:text-[50px] lg:text-[70px] xl:text-[70px] font-bold leading-none text-transparent bg-clip-text bg-gradient-to-r from-[#FFD700] via-[#FFF8DC] to-[#FFD700] px-2"
                style="
                  font-family: 'Stalinist One', sans-serif;
                  text-shadow: 0 0 40px rgba(255, 215, 0, 0.5);
                "
              >
                ${{
                  animatedRewardAmount.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </h2>
              <p
                class="text-[11px] sm:text-[16px] md:text-[20px] lg:text-[28px] xl:text-[32px] font-semibold tracking-[0.2em] md:tracking-[0.3em] text-white mt-1 md:mt-2"
                style="font-family: 'Stalinist One', sans-serif"
              >
                REWARD
              </p>
            </div>
          </div>

          <!-- SHUFFLE (COMMENTED OUT - REPLACED BY STAKE) -->
          <!-- <div v-show="selectedLeaderboard == 'shuffle'">
            <div
              class="flex flex-col items-center justify-center gap-3 md:gap-4 mb-10"
            >
              <a href="https://shuffle.com/?r=Romieinc" target="_blank">
                <img
                  v-motion-pop-visible
                  src="https://shuffle.com/icons/logo.svg"
                  class="w-[200px] sm:w-[250px] md:w-[300px] lg:w-[350px] h-auto"
                  alt="shuffle-logo"
                />
              </a>
              <h1
                class="text-[14px] sm:text-[18px] md:text-[24px] lg:text-[30px] font-bold tracking-[0.25em] md:tracking-[0.3em] text-transparent bg-clip-text bg-gradient-to-r from-[#FFFFFF] via-[#FF7373] to-[#FF0000]"
                style="
                  font-family: 'Stalinist One', sans-serif;
                  text-shadow: 0 0 20px rgba(255, 0, 0, 0.3);
                "
              >
                LEADERBOARD
              </h1>
            </div>
            <div
              v-if="!isPaused"
              class="relative flex flex-col items-center justify-center mt-4 md:mt-6 mb-4 px-4 md:px-8 z-10"
            >
              <h2
                class="text-[20px] sm:text-[30px] md:text-[50px] lg:text-[70px] xl:text-[70px] font-bold leading-none text-transparent bg-clip-text bg-gradient-to-r from-[#FFD700] via-[#FFF8DC] to-[#FFD700] px-2"
                style="
                  font-family: 'Stalinist One', sans-serif;
                  text-shadow: 0 0 40px rgba(255, 215, 0, 0.5);
                "
              >
                ${{
                  animatedRewardAmount.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </h2>
              <p
                class="text-[11px] sm:text-[16px] md:text-[20px] lg:text-[28px] xl:text-[32px] font-semibold tracking-[0.2em] md:tracking-[0.3em] text-white mt-1 md:mt-2"
                style="font-family: 'Stalinist One', sans-serif"
              >
                REWARD
              </p>
            </div>
          </div> -->

          <!-- SKINRAVE (COMMENTED OUT - HIDDEN FOR NOW) -->
          <!-- <div v-show="selectedLeaderboard == 'skinrave'">
            <div
              class="flex flex-col items-center justify-center gap-3 md:gap-4 mb-10"
            >
              <a href="https://skinrave.gg/en?r=romieinc" target="_blank">
                <div class="rounded-xl px-6 py-3">
                  <img
                    v-motion-pop-visible
                    src="https://static.skinrave.gg/skinrave-front-assets/public/logo.svg"
                    class="w-[160px] sm:w-[200px] md:w-[250px] lg:w-[300px] h-auto"
                    alt="skinrave-logo"
                  />
                </div>
              </a>
              <h1
                class="text-[14px] sm:text-[18px] md:text-[24px] lg:text-[30px] font-bold tracking-[0.25em] md:tracking-[0.3em] text-transparent bg-clip-text bg-gradient-to-r from-[#FFFFFF] via-[#FF7373] to-[#FF0000]"
                style="
                  font-family: 'Stalinist One', sans-serif;
                  text-shadow: 0 0 20px rgba(255, 0, 0, 0.3);
                "
              >
                LEADERBOARD
              </h1>
            </div>
            <div
              class="relative flex flex-col items-center justify-center mt-4 md:mt-6 mb-4 px-4 md:px-8 z-10"
            >
              <h2
                class="text-[20px] sm:text-[30px] md:text-[50px] lg:text-[70px] xl:text-[70px] font-bold leading-none text-transparent bg-clip-text bg-gradient-to-r from-[#FFD700] via-[#FFF8DC] to-[#FFD700] px-2"
                style="
                  font-family: 'Stalinist One', sans-serif;
                  text-shadow: 0 0 40px rgba(255, 215, 0, 0.5);
                "
              >
                ${{
                  animatedRewardAmount.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </h2>
              <p
                class="text-[11px] sm:text-[16px] md:text-[20px] lg:text-[28px] xl:text-[32px] font-semibold tracking-[0.2em] md:tracking-[0.3em] text-white mt-1 md:mt-2"
                style="font-family: 'Stalinist One', sans-serif"
              >
                REWARD
              </p>
            </div>
          </div> -->

          <!-- CASEBATTLE (COMMENTED OUT - HIDDEN FOR NOW) -->
          <!-- <div v-show="selectedLeaderboard == 'casebattle'">
            <div
              class="flex flex-col items-center justify-center gap-3 md:gap-4 mb-10 mt-10"
            >
              <a href="https://casebattle.com/r/romieinc" target="_blank">
                <div class="rounded-xl px-6 py-3">
                  <img
                    v-motion-pop-visible
                    src="https://casebattle.com/images/branding/banner.svg"
                    class="w-[160px] sm:w-[200px] md:w-[250px] lg:w-[300px] h-auto"
                    alt="casebattle-logo"
                  />
                </div>
              </a>
              <h1
                class="text-[14px] sm:text-[18px] md:text-[24px] lg:text-[30px] font-bold tracking-[0.25em] md:tracking-[0.3em] text-transparent bg-clip-text bg-gradient-to-r from-[#FFFFFF] via-[#FF7373] to-[#FF0000]"
                style="
                  font-family: 'Stalinist One', sans-serif;
                  text-shadow: 0 0 20px rgba(255, 0, 0, 0.3);
                "
              >
                LEADERBOARD
              </h1>
            </div>
            <div
              class="relative flex flex-col items-center justify-center mt-4 md:mt-6 mb-4 px-4 md:px-8 z-10"
            >
              <h2
                class="text-[20px] sm:text-[30px] md:text-[50px] lg:text-[70px] xl:text-[70px] font-bold leading-none text-transparent bg-clip-text bg-gradient-to-r from-[#FFD700] via-[#FFF8DC] to-[#FFD700] px-2"
                style="
                  font-family: 'Stalinist One', sans-serif;
                  text-shadow: 0 0 40px rgba(255, 215, 0, 0.5);
                "
              >
                ${{
                  animatedRewardAmount.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </h2>
              <p
                class="text-[11px] sm:text-[16px] md:text-[20px] lg:text-[28px] xl:text-[32px] font-semibold tracking-[0.2em] md:tracking-[0.3em] text-white mt-1 md:mt-2"
                style="font-family: 'Stalinist One', sans-serif"
              >
                REWARD
              </p>
            </div>
          </div> -->

          <!-- PACKDRAW (COMMENTED OUT - HIDDEN FOR NOW) -->
          <!-- <div v-show="selectedLeaderboard == 'packdraw'">
            <div class="flex flex-row items-center justify-center mt-10">
              <a
                href="https://packdraw.com/?ref=romieinc"
                class="self-start"
                target="_blank"
                ><img
                  v-motion-pop-visible
                  src="../assets/RomieIncXPackdrawLogo.png"
                  class="hidden md:block max-w-[280px] md:max-w-[330px] xl:max-w-[390px] w-full h-auto"
                  alt="raingg-logo"
              /></a>
              <img
                v-motion-pop-visible
                src="../assets/packdraw-leaderboard-title.png"
                class="px-5 pt-5 max-h-[100px] lg:max-h-[120px] xl:max-h-[170px] h-full w-auto"
                alt="packdraw leaderboard"
              />
            </div>
            <div
              class="relative flex flex-col items-center justify-center mt-4 md:mt-6 mb-4 px-4 md:px-8 z-10"
            >
              <h2
                class="text-[20px] sm:text-[30px] md:text-[50px] lg:text-[70px] xl:text-[70px] font-bold leading-none text-transparent bg-clip-text bg-gradient-to-r from-[#FFD700] via-[#FFF8DC] to-[#FFD700] px-2"
                style="
                  font-family: 'Stalinist One', sans-serif;
                  text-shadow: 0 0 40px rgba(255, 215, 0, 0.5);
                "
              >
                ${{
                  animatedRewardAmount.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </h2>
              <p
                class="text-[11px] sm:text-[16px] md:text-[20px] lg:text-[28px] xl:text-[32px] font-semibold tracking-[0.2em] md:tracking-[0.3em] text-white mt-1 md:mt-2"
                style="font-family: 'Stalinist One', sans-serif"
              >
                REWARD
              </p>
            </div>
          </div> -->

          <!-- CSDROP (COMMENTED OUT - HIDDEN FOR NOW) -->
          <!-- <div v-show="selectedLeaderboard == 'csdrop'" class="relative z-10">
            <div
              class="flex flex-col items-center justify-center gap-3 md:gap-4 mb-10 mt-10"
            >
              <a href="https://csdrop.com" target="_blank">
                <div class="bg-white rounded-xl px-6 py-3">
                  <img
                    v-motion-pop-visible
                    src="https://cdn.csdrop.com/logo_dark_blue_x2"
                    class="w-[160px] sm:w-[200px] md:w-[250px] lg:w-[300px] h-auto"
                    alt="csdrop-logo"
                  />
                </div>
              </a>
              <h1
                class="text-[14px] sm:text-[18px] md:text-[24px] lg:text-[30px] font-bold tracking-[0.25em] md:tracking-[0.3em] text-transparent bg-clip-text bg-gradient-to-r from-[#FFFFFF] via-[#FF7373] to-[#FF0000]"
                style="
                  font-family: 'Stalinist One', sans-serif;
                  text-shadow: 0 0 20px rgba(255, 0, 0, 0.3);
                "
              >
                LEADERBOARD
              </h1>
            </div>
            <div
              class="relative flex flex-col items-center justify-center mt-4 md:mt-6 mb-4 px-4 md:px-8 z-10"
            >
              <h2
                class="text-[20px] sm:text-[30px] md:text-[50px] lg:text-[70px] xl:text-[70px] font-bold leading-none text-transparent bg-clip-text bg-gradient-to-r from-[#FFD700] via-[#FFF8DC] to-[#FFD700] px-2"
                style="
                  font-family: 'Stalinist One', sans-serif;
                  text-shadow: 0 0 40px rgba(255, 215, 0, 0.5);
                "
              >
                ${{ animatedRewardAmount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
              </h2>
              <p
                class="text-[11px] sm:text-[16px] md:text-[20px] lg:text-[28px] xl:text-[32px] font-semibold tracking-[0.2em] md:tracking-[0.3em] text-white mt-1 md:mt-2"
                style="font-family: 'Stalinist One', sans-serif"
              >
                REWARD
              </p>
            </div>
          </div> -->

          <!-- EMPIREDROP (COMMENTED OUT - HIDDEN FOR NOW) -->
          <!-- <div v-show="selectedLeaderboard == 'empiredrop'" class="relative z-10">
            <div
              class="flex flex-col items-center justify-center gap-3 md:gap-4 mb-10 mt-10"
            >
              <a href="https://empiredrop.com" target="_blank">
                <div class="bg-white rounded-xl px-6 py-3">
                  <img
                    v-motion-pop-visible
                    src="https://cdn.empiredrop.com/logo_black.png"
                    class="w-[160px] sm:w-[200px] md:w-[250px] lg:w-[300px] h-auto"
                    alt="empiredrop-logo"
                  />
                </div>
              </a>
              <h1
                class="text-[14px] sm:text-[18px] md:text-[24px] lg:text-[30px] font-bold tracking-[0.25em] md:tracking-[0.3em] text-transparent bg-clip-text bg-gradient-to-r from-[#FFFFFF] via-[#FF7373] to-[#FF0000]"
                style="
                  font-family: 'Stalinist One', sans-serif;
                  text-shadow: 0 0 20px rgba(255, 0, 0, 0.3);
                "
              >
                LEADERBOARD
              </h1>
            </div>
            <div
              class="relative flex flex-col items-center justify-center mt-4 md:mt-6 mb-4 px-4 md:px-8 z-10"
            >
              <h2
                class="text-[20px] sm:text-[30px] md:text-[50px] lg:text-[70px] xl:text-[70px] font-bold leading-none text-transparent bg-clip-text bg-gradient-to-r from-[#FFD700] via-[#FFF8DC] to-[#FFD700] px-2"
                style="
                  font-family: 'Stalinist One', sans-serif;
                  text-shadow: 0 0 40px rgba(255, 215, 0, 0.5);
                "
              >
                ${{ animatedRewardAmount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
              </h2>
              <p
                class="text-[11px] sm:text-[16px] md:text-[20px] lg:text-[28px] xl:text-[32px] font-semibold tracking-[0.2em] md:tracking-[0.3em] text-white mt-1 md:mt-2"
                style="font-family: 'Stalinist One', sans-serif"
              >
                REWARD
              </p>
            </div>
          </div> -->

          <!-- RAIN.GG (COMMENTED OUT FOR FUTURE USE) -->
          <!-- <div v-show="selectedLeaderboard == 'raingg'">
            <div class="flex flex-col items-center justify-center gap-3 md:gap-4 mb-10">
              <a href="https://rain.gg" target="_blank">
                <img
                  v-motion-pop-visible
                  src="../assets/raingg-logo.webp"
                  class="w-[200px] sm:w-[250px] md:w-[300px] lg:w-[350px] h-auto"
                  alt="raingg-logo"
                />
              </a>
              <h1
                class="text-[14px] sm:text-[18px] md:text-[24px] lg:text-[30px] font-bold tracking-[0.25em] md:tracking-[0.3em] text-transparent bg-clip-text bg-gradient-to-r from-[#FFFFFF] via-[#FF7373] to-[#FF0000]"
                style="font-family: 'Stalinist One', sans-serif; text-shadow: 0 0 20px rgba(255, 0, 0, 0.3);"
              >
                LEADERBOARD
              </h1>
            </div>
            <div class="relative flex flex-col items-center justify-center mt-4 md:mt-6 mb-4 px-4 md:px-8 z-10">
              <h2
                class="text-[20px] sm:text-[30px] md:text-[50px] lg:text-[70px] xl:text-[70px] font-bold leading-none text-transparent bg-clip-text bg-gradient-to-r from-[#FFD700] via-[#FFF8DC] to-[#FFD700] px-2"
                style="font-family: 'Stalinist One', sans-serif; text-shadow: 0 0 40px rgba(255, 215, 0, 0.5);"
              >
                ${{ animatedRewardAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
              </h2>
              <p
                class="text-[11px] sm:text-[16px] md:text-[20px] lg:text-[28px] xl:text-[32px] font-semibold tracking-[0.2em] md:tracking-[0.3em] text-white mt-1 md:mt-2"
                style="font-family: 'Stalinist One', sans-serif;"
              >
                REWARD
              </p>
            </div>
          </div> -->

          <!-- CSGOLD (COMMENTED OUT PER CLIENT REQUEST) -->
          <!-- <div v-show="selectedLeaderboard == 'csgold'">
            <div class="flex flex-col items-center justify-center gap-3 md:gap-4 mb-10 mt-10">
              <a href="https://csgold.gg/r/8WLOLW" target="_blank">
                <img
                  v-motion-pop-visible
                  src="https://dv58yh1dcgwcc.cloudfront.net/unsafe/w:384/plain/https://csgold.gg/shared/logo.svg"
                  class="w-[200px] sm:w-[250px] md:w-[300px] lg:w-[350px] h-auto"
                  alt="csgold-logo"
                />
              </a>
              <h1
                class="text-[14px] sm:text-[18px] md:text-[24px] lg:text-[30px] font-bold tracking-[0.25em] md:tracking-[0.3em] text-transparent bg-clip-text bg-gradient-to-r from-[#FFFFFF] via-[#FF7373] to-[#FF0000]"
                style="font-family: 'Stalinist One', sans-serif; text-shadow: 0 0 20px rgba(255, 0, 0, 0.3);"
              >
                LEADERBOARD
              </h1>
            </div>
            <div class="relative flex flex-col items-center justify-center mt-4 md:mt-6 mb-4 px-4 md:px-8 z-10">
              <h2
                class="text-[20px] sm:text-[30px] md:text-[50px] lg:text-[70px] xl:text-[70px] font-bold leading-none text-transparent bg-clip-text bg-gradient-to-r from-[#FFD700] via-[#FFF8DC] to-[#FFD700] px-2"
                style="font-family: 'Stalinist One', sans-serif; text-shadow: 0 0 40px rgba(255, 215, 0, 0.5);"
              >
                ${{ animatedRewardAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
              </h2>
              <p
                class="text-[11px] sm:text-[16px] md:text-[20px] lg:text-[28px] xl:text-[32px] font-semibold tracking-[0.2em] md:tracking-[0.3em] text-white mt-1 md:mt-2"
                style="font-family: 'Stalinist One', sans-serif;"
              >
                REWARD
              </p>
            </div>
          </div> -->

          <!-- LEADERBOARD PAUSED NOTICE -->
          <div
            v-if="isPaused"
            v-motion-slide-visible-bottom
            class="max-w-[90%] md:max-w-[700px] mx-auto mt-4 my-6 px-6 md:px-10 py-6 md:py-8 rounded-lg border-2 border-[#FF0000] bg-gradient-to-r from-[#1B0202] via-[#330000] to-[#1B0202] text-center"
          >
            <h3
              class="text-[#FF0000] font-bold text-lg md:text-2xl mb-3"
              style="
                font-family: 'Stalinist One', sans-serif;
                letter-spacing: 0.1em;
              "
            >
              LEADERBOARD PAUSED
            </h3>
            <p
              class="text-white text-xs md:text-base leading-relaxed"
              style="font-family: 'Russo One', sans-serif"
            >
              The current leaderboard has been temporarily paused. Stay tuned
              for updates on when it will resume.
            </p>
          </div>

          <div
            v-else
            v-motion-slide-visible-bottom
            class="text-center text-white font-medium px-8 py-2 my-4 text-[15px] bg-gradient-to-r from-[#1B0202] via-[#330000_50%] to-[#1B0202] mt-4"
          >
            {{ currentTimer }}
          </div>

          <!-- WAGER ABUSE DISCLAIMER -->
          <div
            v-if="!isPaused"
            v-motion-slide-visible-bottom
            class="max-w-[90%] md:max-w-[1000px] mx-auto my-6 px-4 md:px-6 py-4 md:py-5 rounded-lg border-2 border-[#FF0000] bg-gradient-to-r from-[#1B0202] via-[#330000] to-[#1B0202]"
          >
            <div
              class="flex flex-col md:flex-row items-start md:items-center gap-3 md:gap-4"
            >
              <!-- Warning Icon -->
              <div class="flex-shrink-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  class="w-7 h-7 md:w-9 md:h-9 text-[#FF0000]"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                  />
                </svg>
              </div>

              <!-- Disclaimer Content -->
              <div class="flex-1">
                <h3
                  class="text-[#FF0000] font-bold text-base md:text-lg mb-2"
                  style="
                    font-family: 'Stalinist One', sans-serif;
                    letter-spacing: 0.05em;
                  "
                >
                  DISCLAIMER - WAGER ABUSE WARNING
                </h3>
                <p
                  class="text-white text-xs md:text-sm leading-relaxed"
                  style="font-family: 'Russo One', sans-serif"
                >
                  Wager abuse and artificial leaderboard manipulation are
                  strictly prohibited. The following activities will result in
                  disqualification:
                </p>
                <ul
                  class="text-white text-xs md:text-sm mt-2 md:mt-3 space-y-1 md:space-y-1.5 list-disc list-inside"
                  style="font-family: 'Russo One', sans-serif"
                >
                  <li>
                    Low-risk betting strategies (e.g., 1.01x Limbo, minimal
                    multiplier crashes)
                  </li>
                  <li>
                    Table game abuse (opposite betting on roulette/baccarat,
                    low-risk blackjack patterns)
                  </li>
                  <li>
                    Excessive betting volume with minimal risk (100,000+
                    near-zero risk bets)
                  </li>
                  <li>
                    Any strategies designed to artificially inflate wager
                    amounts
                  </li>
                </ul>
                <p
                  class="text-[#FF7373] text-xs md:text-sm mt-2 md:mt-3 font-semibold"
                  style="font-family: 'Russo One', sans-serif"
                >
                  All suspicious accounts are subject to review and may be
                  removed from the leaderboard.
                </p>
              </div>
            </div>
          </div>

          <div v-if="!isPaused" class="block mt-6">
            <div class="relative flex items-center rounded-full bg-[#440101]">
              <div
                class="absolute top-0 h-full rounded-full bg-gradient-to-r from-[#050505] via-[#5C2027] to-[#8B1259] transition-all duration-300 z-1"
                :style="{
                  width: '50%',
                  left: selectedLeaderboard === 'stake' ? '0%' : '50%',
                }"
              ></div>
              <button
                class="flex-1 px-2 py-3 md:p-5 text-white text-[7px] md:text-[14px] font-bold transition-all duration-300 z-20"
                style="font-family: Stalinist One, sans-serif"
                @click="selectedLeaderboard = 'stake'"
              >
                STAKE
              </button>
              <button
                class="flex-1 px-2 py-3 md:p-5 text-white text-[7px] md:text-[14px] font-bold transition-all duration-300 z-20"
                style="font-family: Stalinist One, sans-serif"
                @click="selectedLeaderboard = 'stakeonly'"
              >
                STAKE ENGINE
              </button>
              <!-- SHUFFLE TAB (COMMENTED OUT - REPLACED BY STAKE) -->
              <!-- <button
                class="flex-1 px-2 py-3 md:p-5 text-white text-[7px] md:text-[14px] font-bold transition-all duration-300 z-20"
                style="font-family: Stalinist One, sans-serif"
                @click="selectedLeaderboard = 'shuffle'"
              >
                SHUFFLE
              </button> -->
              <!-- SKINRAVE TAB (COMMENTED OUT - HIDDEN FOR NOW) -->
              <!-- <button
                class="flex-1 px-2 py-3 md:p-5 text-white text-[7px] md:text-[14px] font-bold transition-all duration-300 z-20"
                style="font-family: Stalinist One, sans-serif"
                @click="selectedLeaderboard = 'skinrave'"
              >
                SKINRAVE
              </button> -->
              <!-- CASEBATTLE TAB (COMMENTED OUT - HIDDEN FOR NOW) -->
              <!-- <button
                class="flex-1 px-2 py-3 md:p-5 text-white text-[7px] md:text-[14px] font-bold transition-all duration-300 z-20"
                style="font-family: Stalinist One, sans-serif"
                @click="selectedLeaderboard = 'casebattle'"
              >
                CASEBATTLE
              </button> -->
              <!-- PACKDRAW TAB (COMMENTED OUT - HIDDEN FOR NOW) -->
              <!-- <button
                class="flex-1 px-2 py-3 md:p-5 text-white text-[7px] md:text-[14px] font-bold transition-all duration-300 z-20"
                style="font-family: Stalinist One, sans-serif"
                @click="selectedLeaderboard = 'packdraw'"
              >
                PACKDRAW
              </button> -->
              <!-- CSDROP TAB (COMMENTED OUT - HIDDEN FOR NOW) -->
              <!-- <button
                class="flex-1 px-2 py-3 md:p-5 text-white text-[7px] md:text-[14px] font-bold transition-all duration-300 z-20"
                style="font-family: Stalinist One, sans-serif"
                @click="selectedLeaderboard = 'csdrop'"
              >
                CSDROP
              </button> -->
              <!-- EMPIREDROP TAB (COMMENTED OUT - HIDDEN FOR NOW) -->
              <!-- <button
                class="flex-1 px-2 py-3 md:p-5 text-white text-[7px] md:text-[14px] font-bold transition-all duration-300 z-20"
                style="font-family: Stalinist One, sans-serif"
                @click="selectedLeaderboard = 'empiredrop'"
              >
                EMPIREDROP
              </button> -->
            </div>
          </div>

          <div v-if="loading == false && !isPaused" class="hidden md:block">
            <div
              class="flex justify-center mt-8 mb:mb-24"
              style="font-family: Russo One, sans-serif"
            >
              <table
                class="w-full border-separate lg:w-auto border-spacing-y-6"
              >
                <thead
                  v-motion-slide-visible-bottom
                  class="rounded-2xl font-['Stalinist_One']"
                  :class="
                    selectedLeaderboard == 'raingg' ? 'bg-black' : 'bg-black'
                  "
                >
                  <tr>
                    <th
                      class="px-1 md:px-6 lg:pr-20 lg:pl-8 py-2 md:py-4 text-transparent text-lg xl:text-[25px] font-normal xl:font-semibold text-left rounded-l-full bg-clip-text bg-gradient-to-r from-[#FF0000] via-[#FF7373_50%] to-[#FF0000]"
                    >
                      Ranks
                    </th>
                    <th
                      class="px-1 md:px-10 lg:px-16 py-2 md:py-4 text-transparent text-lg xl:text-[25px] font-normal xl:font-semibold text-center bg-clip-text bg-gradient-to-r from-[#FF0000] via-[#FF7373_50%] to-[#FF0000]"
                    >
                      User
                    </th>
                    <th
                      class="px-1 md:px-10 lg:px-16 py-2 md:py-4 text-transparent text-lg xl:text-[25px] font-normal xl:font-semibold text-center bg-clip-text bg-gradient-to-r from-[#FF0000] via-[#FF7373_50%] to-[#FF0000]"
                    >
                      Amount
                    </th>
                    <th
                      class="px-1 md:px-8 lg:pl-16 lg:pr-8 py-2 md:py-4 text-transparent text-lg xl:text-[25px] font-normal xl:font-semibold text-right rounded-r-full bg-clip-text bg-gradient-to-r from-[#FF0000] via-[#FF7373_50%] to-[#FF0000]"
                    >
                      Prize
                    </th>
                  </tr>
                </thead>

                <tbody class="mt-4">
                  <tr v-if="displayedLeaderboard.length === 0">
                    <td
                      colspan="4"
                      class="py-10 text-center text-white text-[16px] font-normal opacity-60"
                      style="font-family: 'Russo One', sans-serif"
                    >
                      No leaderboard data available yet.
                    </td>
                  </tr>
                  <tr
                    v-motion-slide-visible-bottom
                    v-for="(item, index) in displayedLeaderboard"
                    :key="index"
                    :class="
                      index < 3
                        ? 'bg-gradient-to-r from-[#840000] via-[#350003] to-[#57003F]'
                        : ''
                    "
                  >
                    <td
                      class="px-1 md:px-[45px] lg:px-10 py-2 md:py-4 whitespace-nowrap text-[18px] font-semibold text-left"
                    >
                      <div class="flex flex-row items-center gap-2">
                        <div class="text-white">
                          {{ getOrdinalSuffix(index + 1) }}
                        </div>
                      </div>
                    </td>
                    <td
                      class="px-1 md:px-[45px] lg:px-24 py-2 md:py-4 whitespace-nowrap text-[18px] text-white font-thin text-center"
                    >
                      {{
                        item.placeholder
                          ? "-"
                          : isStakeLeaderboard
                          ? item.username
                          : maskString(
                          selectedLeaderboard === "csgobig"
                            ? item.name
                            : selectedLeaderboard === "casebattle"
                            ? item.user?.username
                            : item.username,
                        )
                      }}
                    </td>
                    <td
                      class="flex justify-center items-center px-1 md:px-[45px] lg:px-24 py-2 md:py-4 whitespace-nowrap text-[18px] text-white font-thin text-center"
                    >
                      <img
                        v-if="selectedLeaderboard === 'csgobig'"
                        src="../assets/clashgg-icon.webp"
                        alt="ClashGG Icon"
                        style="width: 16px; height: 16px; margin-right: 4px"
                      />
                      <template v-if="item.placeholder">-</template>
                      <template v-else-if="selectedLeaderboard === 'shuffle'">
                        <div class="flex flex-col items-center leading-snug">
                          <span>${{ parseFloat(item?.wagerAmount || 0).toFixed(2) }}</span>
                          <span class="text-[13px] text-gray-300 whitespace-nowrap">${{ parseFloat(item?.weightedWagerAmount || 0).toFixed(2) }} weighted</span>
                        </div>
                      </template>
                      <template v-else-if="isStakeLeaderboard">
                        <div class="flex flex-col items-center leading-snug">
                          <span>${{ parseFloat(item?.wageredAmount || 0).toFixed(2) }}</span>
                          <span v-if="selectedLeaderboard === 'stake'" class="text-[13px] text-gray-300 whitespace-nowrap">${{ parseFloat(item?.weightedWageredAmount || 0).toFixed(2) }} weighted</span>
                        </div>
                      </template>
                      <template v-else>
                        {{
                          selectedLeaderboard === "roobet"
                            ? `$${item?.weightedWagered?.toFixed(2).toLocaleString()}`
                            : selectedLeaderboard === "casebattle"
                            ? `$${parseFloat(item?.amount || 0).toFixed(2).toLocaleString()}`
                            : item.amount
                        }}
                      </template>
                    </td>
                    <td
                      class="px-1 md:px-[45px] lg:px-8 py-2 md:py-4 whitespace-nowrap text-[18px] text-white font-thin text-right"
                    >
                      {{ getRewardValue(index) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="loading == false && !isPaused" class="block md:hidden">
            <div
              class="flex justify-center mt-8 text-xl mb:mb-24"
              style="font-family: Russo One, sans-serif"
            >
              <table class="w-full lg:w-auto">
                <thead v-motion-slide-visible-bottom>
                  <tr>
                    <th
                      class="md:px-[85px] lg:px-28 py-2 md:py-10 text-white text-[14px] md:text-2xl font-bold text-left"
                    >
                      Ranks
                    </th>
                    <th
                      class="md:px-[85px] lg:px-28 py-2 md:py-10 text-white text-[14px] md:text-2xl font-bold text-center"
                    >
                      User
                    </th>
                    <th
                      class="md:px-[85px] lg:px-28 py-2 md:py-10 text-white text-[14px] md:text-2xl font-bold text-center"
                    >
                      Amount
                    </th>
                    <th
                      class="md:px-[85px] lg:px-28 py-2 md:py-10 text-white text-[14px] md:text-2xl font-bold text-right"
                    >
                      Prize
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="displayedLeaderboard.length === 0">
                    <td
                      colspan="4"
                      class="py-8 text-center text-white text-[13px] font-normal opacity-60"
                      style="font-family: 'Russo One', sans-serif"
                    >
                      No leaderboard data available yet.
                    </td>
                  </tr>
                  <tr
                    v-motion-slide-visible-bottom
                    v-for="(item, index) in displayedLeaderboard"
                    :key="index"
                  >
                    <td
                      class="px-1 md:px-[85px] lg:px-28 py-2 md:py-5 whitespace-nowrap text-[14px] text-white font-normal text-left"
                    >
                      {{ getOrdinalSuffix(index + 1) }}
                    </td>
                    <td
                      class="px-1 md:px-[85px] lg:px-28 py-2 md:py-5 whitespace-nowrap text-[14px] text-white font-normal text-center"
                    >
                      {{
                        item.placeholder
                          ? "-"
                          : isStakeLeaderboard
                          ? item.username
                          : maskString(
                          selectedLeaderboard === "csgobig"
                            ? item.name
                            : selectedLeaderboard === "casebattle"
                            ? item.user?.username
                            : item.username,
                        )
                      }}
                    </td>
                    <td
                      class="px-1 md:px-[85px] lg:px-28 py-2 md:py-5 whitespace-nowrap text-[14px] text-white font-normal text-center"
                    >
                      <template v-if="item.placeholder">-</template>
                      <template v-else-if="selectedLeaderboard === 'shuffle'">
                        <div class="flex flex-col items-center leading-snug">
                          <span>${{ parseFloat(item?.wagerAmount || 0).toFixed(2) }}</span>
                          <span class="text-[11px] text-gray-300 whitespace-nowrap">${{ parseFloat(item?.weightedWagerAmount || 0).toFixed(2) }} weighted</span>
                        </div>
                      </template>
                      <template v-else-if="isStakeLeaderboard">
                        <div class="flex flex-col items-center leading-snug">
                          <span>${{ parseFloat(item?.wageredAmount || 0).toFixed(2) }}</span>
                          <span v-if="selectedLeaderboard === 'stake'" class="text-[11px] text-gray-300 whitespace-nowrap">${{ parseFloat(item?.weightedWageredAmount || 0).toFixed(2) }} weighted</span>
                        </div>
                      </template>
                      <template v-else>
                        {{
                          selectedLeaderboard === "roobet"
                            ? `$${item?.weightedWagered?.toFixed(2).toLocaleString()}`
                            : selectedLeaderboard === "casebattle"
                            ? `$${parseFloat(item?.amount || 0).toFixed(2).toLocaleString()}`
                            : item.amount
                        }}
                      </template>
                    </td>
                    <td
                      class="px-1 md:px-[85px] lg:px-28 py-2 md:py-5 whitespace-nowrap text-[14px] text-white font-normal text-right"
                    >
                      {{ getRewardValue(index) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>

    <PrevLeaderBoardSection ref="PrevLeaderBoardSection" />
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment-timezone";
import PrevLeaderBoardSection from "./PrevLeaderBoardSection.vue";

export default {
  components: {
    PrevLeaderBoardSection,
  },
  data() {
    return {
      // Set to false to resume the current leaderboard
      isPaused: false,
      selectedLeaderboard: "stake",
      currentLeaderboard: [],
      currentLeaderboardCount: 8,
      baseUrl: `${process.env.VUE_APP_BASE_API}`,
      loading: false,

      stakeLeaderboard: [],
      stakeNotFormattedStartDate: null,
      stakeNotFormattedEndDate: null,
      stakeTimer: "",

      stakeonlyLeaderboard: [],
      stakeonlyNotFormattedStartDate: null,
      stakeonlyNotFormattedEndDate: null,
      stakeonlyTimer: "",

      shuffleLeaderboard: [],
      shuffleNotFormattedStartDate: null,
      shuffleNotFormattedEndDate: null,
      shuffleTimer: "",

      roobetLeaderboard: [],
      roobetNotFormattedEndDate: null,
      roobetTimer: "",

      // packdrawLeaderboard: [],
      // packdrawNotFormattedStartDate: null,
      // packdrawNotFormattedEndDate: null,
      // packdrawTimer: "",

      // skinraveLeaderboard: [],
      // skinraveNotFormattedStartDate: null,
      // skinraveNotFormattedEndDate: null,
      // skinraveTimer: "",

      casebattleLeaderboard: [],
      casebattleNotFormattedStartDate: null,
      casebattleNotFormattedEndDate: null,
      casebattleTimer: "",

      // rainggLeaderboard: [],
      // rainggNotFormattedEndDate: null,
      // rainggTimer: "",

      // csgoldLeaderboard: [],
      // csgoldNotFormattedEndDate: null,
      // csgoldTimer: "",

      // csdropLeaderboard: [],
      // csdropNotFormattedStartDate: null,
      // csdropNotFormattedEndDate: null,
      // csdropTimer: "",

      // empiredropLeaderboard: [],
      // empiredropNotFormattedStartDate: null,
      // empiredropNotFormattedEndDate: null,
      // empiredropTimer: "",

      targetRewardAmount: 0,
      animatedRewardAmount: 0,
    };
  },
  computed: {
    displayedLeaderboard() {
      // Pad with placeholder rows so every prize position is visible
      return Array.from(
        { length: this.currentLeaderboardCount },
        (_, i) => this.currentLeaderboard[i] || { placeholder: true },
      );
    },
    isStakeLeaderboard() {
      return ["stake", "stakeonly"].includes(this.selectedLeaderboard);
    },
    currentTotalReward() {
      let prizes = [];
      switch (this.selectedLeaderboard) {
        case "stake":
          prizes = this.getStakePrizes();
          break;
        case "stakeonly":
          prizes = this.getStakeOnlyPrizes();
          break;
        case "shuffle":
          prizes = JSON.parse(
            `${process.env.VUE_APP_SHUFFLE_PRIZES_CURRENT}` || "[]",
          );
          break;
        case "roobet":
          prizes = JSON.parse(
            `${process.env.VUE_APP_ROOBET_PRIZES_CURRENT}` || "[]",
          );
          break;
        // case "skinrave":
        //   prizes = JSON.parse(
        //     `${process.env.VUE_APP_SKINRAVE_PRIZES_CURRENT}` || "[]",
        //   );
        //   break;
        case "casebattle":
          prizes = JSON.parse(
            `${process.env.VUE_APP_CASEBATTLE_PRIZES_CURRENT}` || "[]",
          );
          break;
        // case "packdraw":
        //   prizes = JSON.parse(
        //     `${process.env.VUE_APP_PACKDRAW_PRIZES_CURRENT}` || "[]",
        //   );
        //   break;
        // case 'raingg':
        //   prizes = JSON.parse(`${process.env.VUE_APP_RAINGG_PRIZES_CURRENT}` || "[]");
        //   break;
        // case 'csgold':
        //   prizes = JSON.parse(`${process.env.VUE_APP_CSGOLD_PRIZES_CURRENT}` || "[]");
        //   break;
        // case "csdrop":
        //   prizes = JSON.parse(`${process.env.VUE_APP_CSDROP_PRIZES_CURRENT}` || "[]");
        //   break;
        // case "empiredrop":
        //   prizes = JSON.parse(`${process.env.VUE_APP_EMPIREDROP_PRIZES_CURRENT}` || "[]");
        //   break;
      }
      return prizes.reduce((sum, prize) => sum + prize, 0);
    },
    currentTimer() {
      const startDateMap = {
        stake: this.stakeNotFormattedStartDate,
        stakeonly: this.stakeonlyNotFormattedStartDate,
        shuffle: this.shuffleNotFormattedStartDate,
        // skinrave: this.skinraveNotFormattedStartDate,
        casebattle: this.casebattleNotFormattedStartDate,
        // packdraw: this.packdrawNotFormattedStartDate,
        // csdrop: this.csdropNotFormattedStartDate,
        // empiredrop: this.empiredropNotFormattedStartDate,
      };
      const timerMap = {
        stake: this.stakeTimer,
        stakeonly: this.stakeonlyTimer,
        shuffle: this.shuffleTimer,
        // skinrave: this.skinraveTimer,
        casebattle: this.casebattleTimer,
        // packdraw: this.packdrawTimer,
        // csdrop: this.csdropTimer,
        // empiredrop: this.empiredropTimer,
      };

      const startDate = startDateMap[this.selectedLeaderboard];
      if (startDate) {
        const now = moment.tz("America/New_York");
        const start = moment.tz(startDate, "America/New_York");
        console.log("now: ", now.format());
        console.log("start: ", start.format());
        if (now.isBefore(start, "seconds")) {
          console.log(
            'Current time is before the start date. Displaying "Leaderboard will start soon".',
          );
          return "Leaderboard will start soon";
        }
      }

      return timerMap[this.selectedLeaderboard] || "";
    },
  },
  methods: {
    init() {
      this.getStakeLeaderboard();
      this.getStakeOnlyLeaderboard();
      // this.getShuffleLeaderboard();
      // this.getSkinraveLeaderboard();
      this.getCasebattleLeaderboard();
      // this.getRoobetLeaderboard();
      // this.getPackdrawLeaderboard();
      // this.getRainggLeaderboard();
      // this.getCsgoldLeaderboard();
      // this.getCsdropLeaderboard();
      // this.getEmpiredropLeaderboard();
    },

    animateCountUp(newTarget = null) {
      const duration = 1000; // 1 second
      const startTime = Date.now();
      const startValue = this.animatedRewardAmount;
      const endValue = newTarget !== null ? newTarget : this.currentTotalReward;

      const animate = () => {
        const currentTime = Date.now();
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // Easing function for smooth animation (easeOutCubic)
        const easeProgress = 1 - Math.pow(1 - progress, 3);

        this.animatedRewardAmount =
          startValue + (endValue - startValue) * easeProgress;

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          this.animatedRewardAmount = endValue;
        }
      };

      animate();
    },

    getNextTargetDate(notFormattedEndDate) {
      // const now = moment.tz("America/New_York");
      const now = moment().utc();
      let targetDate = moment
        .tz(notFormattedEndDate, "America/New_York")
        // .hour(23)
        // .minute(59)
        // .second(59)
        .subtract(1, "seconds");
      // console.log("Roobet Target Date (NY):", targetDate.format());
      // let targetDate = moment(this.roobetNotFormattedEndDate).utc();

      if (now.isSameOrAfter(targetDate)) {
        targetDate.add(1, "month");
      }

      return targetDate;
    },

    updateTimer(notFormattedEndDate, type, targetDate, timerInterval) {
      const nowEst = moment.tz("America/New_York");
      // const nowEst = moment().utc();
      const distance = targetDate.diff(nowEst);

      if (distance < 0) {
        this.timer = "Leaderboard ended";
        this.init();
        this.$refs.PrevLeaderBoardSection.init();
        clearInterval(timerInterval);

        targetDate = this.getNextTargetDate(notFormattedEndDate);

        switch (type) {
          case "stake":
            this.startStakeTimer();
            break;
          case "stakeonly":
            this.startStakeOnlyTimer();
            break;
          case "shuffle":
            this.startShuffleTimer();
            break;
          case "roobet":
            this.startRoobetTimer();
            break;
          // case "skinrave":
          //   this.startSkinraveTimer();
          //   break;
          case "casebattle":
            this.startCasebattleTimer();
            break;
          // case "packdraw":
          //   this.startPackdrawTimer();
          //   break;
          // case 'raingg':
          //   this.startRainggTimer();
          //   break;
          // case 'csgold':
          //   this.startCsgoldTimer();
          //   break;
          // case "csdrop":
          //   this.startCsdropTimer();
          //   break;
          // case "empiredrop":
          //   this.startEmpiredropTimer();
          //   break;
        }
      } else {
        const duration = moment.duration(distance);
        const days = Math.floor(duration.asDays());
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();

        switch (type) {
          case "stake":
            this.stakeTimer = `${days}d ${hours}h ${minutes}m ${seconds}s`;
            break;
          case "stakeonly":
            this.stakeonlyTimer = `${days}d ${hours}h ${minutes}m ${seconds}s`;
            break;
          case "shuffle":
            this.shuffleTimer = `${days}d ${hours}h ${minutes}m ${seconds}s`;
            break;
          case "roobet":
            this.roobetTimer = `${days}d ${hours}h ${minutes}m ${seconds}s`;
            break;
          // case "skinrave":
          //   this.skinraveTimer = `${days}d ${hours}h ${minutes}m ${seconds}s`;
          //   break;
          case "casebattle":
            this.casebattleTimer = `${days}d ${hours}h ${minutes}m ${seconds}s`;
            break;
          // case "packdraw":
          //   this.packdrawTimer = `${days}d ${hours}h ${minutes}m ${seconds}s`;
          //   break;
          // case 'raingg':
          //   this.rainggTimer = `${days}d ${hours}h ${minutes}m ${seconds}s`;
          //   break;
          // case 'csgold':
          //   this.csgoldTimer = `${days}d ${hours}h ${minutes}m ${seconds}s`;
          //   break;
          // case "csdrop":
          //   this.csdropTimer = `${days}d ${hours}h ${minutes}m ${seconds}s`;
          //   break;
          // case "empiredrop":
          //   this.empiredropTimer = `${days}d ${hours}h ${minutes}m ${seconds}s`;
          //   break;
        }
      }
    },

    maskString(str) {
      if (!str || str.length < 2) {
        return str;
      }
      if (!str || str.length <= 4) {
        const start = str.slice(0, 1);
        const end = str.slice(-1);
        const middleAsterisks = "*".repeat(str.length - 2);

        return `${start}${middleAsterisks}${end}`;
      } else {
        const start = str.slice(0, 2);
        const end = str.slice(-2);
        const middleAsterisks = "*".repeat(str.length - 4);

        return `${start}${middleAsterisks}${end}`;
      }
    },
    formatDateNow() {
      return moment().utc().format("MM/DD/YYYY");
    },

    getOrdinalSuffix(n) {
      const s = ["th", "st", "nd", "rd"],
        v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    },

    getRewardValue(rank) {
      let currentPrizes = [];

      switch (this.selectedLeaderboard) {
        case "stake":
          currentPrizes = this.getStakePrizes();
          break;
        case "stakeonly":
          currentPrizes = this.getStakeOnlyPrizes();
          break;
        case "shuffle":
          currentPrizes = JSON.parse(
            `${process.env.VUE_APP_SHUFFLE_PRIZES_CURRENT}` || "[]",
          );
          break;
        case "roobet":
          currentPrizes = JSON.parse(
            `${process.env.VUE_APP_ROOBET_PRIZES_CURRENT}` || "[]",
          );
          break;
        // case "skinrave":
        //   currentPrizes = JSON.parse(
        //     `${process.env.VUE_APP_SKINRAVE_PRIZES_CURRENT}` || "[]",
        //   );
        //   break;
        case "casebattle":
          currentPrizes = JSON.parse(
            `${process.env.VUE_APP_CASEBATTLE_PRIZES_CURRENT}` || "[]",
          );
          break;
        // case "packdraw":
        //   currentPrizes = JSON.parse(
        //     `${process.env.VUE_APP_PACKDRAW_PRIZES_CURRENT}` || "[]",
        //   );
        //   break;
        // case 'raingg':
        //   currentPrizes = JSON.parse(`${process.env.VUE_APP_RAINGG_PRIZES_CURRENT}` || "[]");
        //   break;
        // case 'csgold':
        //   currentPrizes = JSON.parse(`${process.env.VUE_APP_CSGOLD_PRIZES_CURRENT}` || "[]");
        //   break;
        // case "csdrop":
        //   currentPrizes = JSON.parse(`${process.env.VUE_APP_CSDROP_PRIZES_CURRENT}` || "[]");
        //   break;
        // case "empiredrop":
        //   currentPrizes = JSON.parse(`${process.env.VUE_APP_EMPIREDROP_PRIZES_CURRENT}` || "[]");
        //   break;
        default:
          currentPrizes = [];
      }

      if (rank >= currentPrizes.length) {
        return "$0";
      }
      return `$${currentPrizes[rank]}`;
    },

    getStakePrizes() {
      return process.env.VUE_APP_STAKE_PRIZES_CURRENT
        ? JSON.parse(process.env.VUE_APP_STAKE_PRIZES_CURRENT)
        : [];
    },

    async getStakeLeaderboard() {
      try {
        const leaderboardRes = await axios.get(
          `${this.baseUrl}/api/leaderboard/stake`,
          {
            headers: { "x-api-key": process.env.VUE_APP_X_API_KEY },
          },
        );
        this.stakeLeaderboard = leaderboardRes.data.leaderboard;
        this.stakeNotFormattedStartDate = leaderboardRes.data.startDate;
        this.stakeNotFormattedEndDate = leaderboardRes.data.endDate;
        this.startStakeTimer();
        if (this.selectedLeaderboard === "stake") {
          this.currentLeaderboard = this.stakeLeaderboard;
          this.currentLeaderboardCount = this.getStakePrizes().length;
          this.$nextTick(() => {
            this.animateCountUp();
          });
        }
      } catch (e) {
        console.warn("Failed to fetch Stake leaderboard", e);
      }
    },

    getStakeOnlyPrizes() {
      return process.env.VUE_APP_STAKEONLY_PRIZES_CURRENT
        ? JSON.parse(process.env.VUE_APP_STAKEONLY_PRIZES_CURRENT)
        : [];
    },

    async getStakeOnlyLeaderboard() {
      try {
        const leaderboardRes = await axios.get(
          `${this.baseUrl}/api/leaderboard/stakeonly`,
          {
            headers: { "x-api-key": process.env.VUE_APP_X_API_KEY },
          },
        );
        this.stakeonlyLeaderboard = leaderboardRes.data.leaderboard;
        this.stakeonlyNotFormattedStartDate = leaderboardRes.data.startDate;
        this.stakeonlyNotFormattedEndDate = leaderboardRes.data.endDate;
        this.startStakeOnlyTimer();
        if (this.selectedLeaderboard === "stakeonly") {
          this.currentLeaderboard = this.stakeonlyLeaderboard;
          this.currentLeaderboardCount = this.getStakeOnlyPrizes().length;
          this.$nextTick(() => {
            this.animateCountUp();
          });
        }
      } catch (e) {
        console.warn("Failed to fetch Stake Engine leaderboard", e);
      }
    },

    async getShuffleLeaderboard() {
      try {
        const leaderboardRes = await axios.get(
          `${this.baseUrl}/api/leaderboard/shuffle`,
          {
            headers: { "x-api-key": process.env.VUE_APP_X_API_KEY },
          },
        );
        this.shuffleLeaderboard = leaderboardRes.data.leaderboard;
        this.shuffleNotFormattedStartDate = leaderboardRes.data.startDate;
        this.shuffleNotFormattedEndDate = leaderboardRes.data.endDate;
        this.startShuffleTimer();
        this.currentLeaderboard = this.shuffleLeaderboard;
        this.currentLeaderboardCount = JSON.parse(
          `${process.env.VUE_APP_SHUFFLE_PRIZES_CURRENT}` || "[]",
        ).length;
        // Trigger animation after data is loaded
        this.$nextTick(() => {
          this.animateCountUp();
        });
      } catch (e) {
        console.warn("Failed to fetch Shuffle leaderboard", e);
      }
    },

    async getRoobetLeaderboard() {
      try {
        const leaderboardRes = await axios.get(
          `${this.baseUrl}/api/leaderboard/roobet`,
          {
            headers: { "x-api-key": process.env.VUE_APP_X_API_KEY },
          },
        );
        this.roobetLeaderboard = leaderboardRes.data.leaderboard;
        this.roobetNotFormattedEndDate = leaderboardRes.data.endDate;
        this.startRoobetTimer();
      } catch (e) {
        console.warn("Failed to fetch Roobet leaderboard", e);
      }
    },

    // async getSkinraveLeaderboard() {
    //   try {
    //     const leaderboardRes = await axios.get(
    //       `${this.baseUrl}/api/leaderboard/skinrave`,
    //       {
    //         headers: { "x-api-key": process.env.VUE_APP_X_API_KEY },
    //       },
    //     );
    //     this.skinraveLeaderboard = leaderboardRes.data.leaderboard;
    //     this.skinraveNotFormattedStartDate = leaderboardRes.data.startDate;
    //     this.skinraveNotFormattedEndDate = leaderboardRes.data.endDate;
    //     this.startSkinraveTimer();
    //     if (this.selectedLeaderboard === "skinrave") {
    //       this.currentLeaderboard = this.skinraveLeaderboard;
    //       this.currentLeaderboardCount = JSON.parse(
    //         `${process.env.VUE_APP_SKINRAVE_PRIZES_CURRENT}` || "[]",
    //       ).length;
    //       this.$nextTick(() => {
    //         this.animateCountUp();
    //       });
    //     }
    //   } catch (e) {
    //     console.warn("Failed to fetch Skinrave leaderboard", e);
    //   }
    // },

    async getCasebattleLeaderboard() {
      try {
        const leaderboardRes = await axios.get(
          `${this.baseUrl}/api/leaderboard/casebattle`,
          {
            headers: { "x-api-key": process.env.VUE_APP_X_API_KEY },
          },
        );
        this.casebattleLeaderboard = leaderboardRes.data.leaderboard;
        this.casebattleNotFormattedStartDate = leaderboardRes.data.startDate;
        this.casebattleNotFormattedEndDate = leaderboardRes.data.endDate;
        this.startCasebattleTimer();
        if (this.selectedLeaderboard === "casebattle") {
          this.currentLeaderboard = this.casebattleLeaderboard;
          this.currentLeaderboardCount = JSON.parse(
            `${process.env.VUE_APP_CASEBATTLE_PRIZES_CURRENT}` || "[]",
          ).length;
          this.$nextTick(() => {
            this.animateCountUp();
          });
        }
      } catch (e) {
        console.warn("Failed to fetch Casebattle leaderboard", e);
      }
    },

    // async getPackdrawLeaderboard() {
    //   try {
    //     const leaderboardRes = await axios.get(
    //       `${this.baseUrl}/api/leaderboard/packdraw`,
    //       {
    //         headers: { "x-api-key": process.env.VUE_APP_X_API_KEY },
    //       },
    //     );
    //     this.packdrawLeaderboard = leaderboardRes.data.leaderboard;
    //     this.packdrawNotFormattedStartDate = leaderboardRes.data.startDate;
    //     this.packdrawNotFormattedEndDate = leaderboardRes.data.endDate;
    //     this.startPackdrawTimer();
    //   } catch (e) {
    //     console.warn("Failed to fetch Packdraw leaderboard", e);
    //   }
    // },

    // async getRainggLeaderboard() {
    //   try {
    //     const leaderboardRes = await axios.get(`${this.baseUrl}/api/leaderboard/raingg`, {
    //       headers: {"x-api-key": process.env.VUE_APP_X_API_KEY}
    //     });
    //     this.rainggLeaderboard = leaderboardRes.data.leaderboard;
    //     this.rainggNotFormattedEndDate = leaderboardRes.data.endDate;
    //     this.startRainggTimer();
    //   } catch (e) {
    //     console.warn("Failed to fetch Rain.gg leaderboard", e);
    //   }
    // },

    // async getCsgoldLeaderboard() {
    //   try {
    //     const leaderboardRes = await axios.get(`${this.baseUrl}/api/leaderboard/csgold`, {
    //       headers: {"x-api-key": process.env.VUE_APP_X_API_KEY}
    //     });
    //     this.csgoldLeaderboard = leaderboardRes.data.leaderboard;
    //     this.csgoldNotFormattedEndDate = leaderboardRes.data.endDate;
    //     this.startCsgoldTimer();
    //   } catch (e) {
    //     console.warn("Failed to fetch Csgold leaderboard", e);
    //   }
    // },

    startStakeTimer() {
      let targetDate = this.getNextTargetDate(this.stakeNotFormattedEndDate);
      let timerInterval;

      this.updateTimer(
        this.stakeNotFormattedEndDate,
        "stake",
        targetDate,
        timerInterval,
      );
      timerInterval = setInterval(
        () =>
          this.updateTimer(
            this.stakeNotFormattedEndDate,
            "stake",
            targetDate,
            timerInterval,
          ),
        1000,
      );
    },

    startStakeOnlyTimer() {
      let targetDate = this.getNextTargetDate(this.stakeonlyNotFormattedEndDate);
      let timerInterval;

      this.updateTimer(
        this.stakeonlyNotFormattedEndDate,
        "stakeonly",
        targetDate,
        timerInterval,
      );
      timerInterval = setInterval(
        () =>
          this.updateTimer(
            this.stakeonlyNotFormattedEndDate,
            "stakeonly",
            targetDate,
            timerInterval,
          ),
        1000,
      );
    },

    startShuffleTimer() {
      let targetDate = this.getNextTargetDate(this.shuffleNotFormattedEndDate);
      let timerInterval;

      this.updateTimer(
        this.shuffleNotFormattedEndDate,
        "shuffle",
        targetDate,
        timerInterval,
      );
      timerInterval = setInterval(
        () =>
          this.updateTimer(
            this.shuffleNotFormattedEndDate,
            "shuffle",
            targetDate,
            timerInterval,
          ),
        1000,
      );
    },

    startRoobetTimer() {
      let targetDate = this.getNextTargetDate(this.roobetNotFormattedEndDate);
      let timerInterval;

      // const updateTimer = () => {
      //   const nowEst = moment.tz("America/New_York");
      //   // const nowEst = moment().utc();
      //   const distance = targetDate.diff(nowEst);

      //   if (distance < 0) {
      //     this.timer = "Leaderboard ended";
      //     this.init();
      //     this.$refs.PrevLeaderBoardSection.init();
      //     clearInterval(timerInterval);

      //     targetDate = this.getNextTargetDate(this.roobetNotFormattedEndDate);
      //     this.startRoobetTimer();
      //   } else {
      //     const duration = moment.duration(distance);
      //     const days = Math.floor(duration.asDays());
      //     const hours = duration.hours();
      //     const minutes = duration.minutes();
      //     const seconds = duration.seconds();

      //     this.roobetTimer = `${days}d ${hours}h ${minutes}m ${seconds}s`;
      //   }
      // };

      this.updateTimer(
        this.roobetNotFormattedEndDate,
        "roobet",
        targetDate,
        timerInterval,
      );
      timerInterval = setInterval(
        () =>
          this.updateTimer(
            this.roobetNotFormattedEndDate,
            "roobet",
            targetDate,
            timerInterval,
          ),
        1000,
      );
    },

    // startSkinraveTimer() {
    //   let targetDate = this.getNextTargetDate(this.skinraveNotFormattedEndDate);
    //   let timerInterval;
    //   this.updateTimer(this.skinraveNotFormattedEndDate, "skinrave", targetDate, timerInterval);
    //   timerInterval = setInterval(
    //     () => this.updateTimer(this.skinraveNotFormattedEndDate, "skinrave", targetDate, timerInterval),
    //     1000,
    //   );
    // },

    startCasebattleTimer() {
      let targetDate = this.getNextTargetDate(
        this.casebattleNotFormattedEndDate,
      );
      let timerInterval;

      this.updateTimer(
        this.casebattleNotFormattedEndDate,
        "casebattle",
        targetDate,
        timerInterval,
      );
      timerInterval = setInterval(
        () =>
          this.updateTimer(
            this.casebattleNotFormattedEndDate,
            "casebattle",
            targetDate,
            timerInterval,
          ),
        1000,
      );
    },

    // startPackdrawTimer() {
    //   let targetDate = this.getNextTargetDate(this.packdrawNotFormattedEndDate);
    //   let timerInterval;

    //   this.updateTimer(
    //     this.packdrawNotFormattedEndDate,
    //     "packdraw",
    //     targetDate,
    //     timerInterval,
    //   );
    //   timerInterval = setInterval(
    //     () =>
    //       this.updateTimer(
    //         this.packdrawNotFormattedEndDate,
    //         "packdraw",
    //         targetDate,
    //         timerInterval,
    //       ),
    //     1000,
    //   );
    // },

    // startRainggTimer() {
    //   let targetDate = this.getNextTargetDate(this.rainggNotFormattedEndDate);
    //   let timerInterval;

    //   this.updateTimer(this.rainggNotFormattedEndDate, 'raingg', targetDate, timerInterval);
    //   timerInterval = setInterval(() => this.updateTimer(this.rainggNotFormattedEndDate, 'raingg', targetDate, timerInterval), 1000);
    // },

    // startCsgoldTimer() {
    //   let targetDate = this.getNextTargetDate(this.csgoldNotFormattedEndDate);
    //   let timerInterval;

    //   this.updateTimer(this.csgoldNotFormattedEndDate, 'csgold', targetDate, timerInterval);
    //   timerInterval = setInterval(() => this.updateTimer(this.csgoldNotFormattedEndDate, 'csgold', targetDate, timerInterval), 1000);
    // },

    // async getCsdropLeaderboard() {
    //   try {
    //     const leaderboardRes = await axios.get(
    //       `${this.baseUrl}/api/leaderboard/csdrop`,
    //       { headers: { "x-api-key": process.env.VUE_APP_X_API_KEY } },
    //     );
    //     this.csdropLeaderboard = leaderboardRes.data.leaderboard;
    //     this.csdropNotFormattedStartDate = leaderboardRes.data.startDate;
    //     this.csdropNotFormattedEndDate = leaderboardRes.data.endDate;
    //     this.startCsdropTimer();
    //   } catch (e) {
    //     console.warn("Failed to fetch CSDROP leaderboard", e);
    //   }
    // },

    // async getEmpiredropLeaderboard() {
    //   try {
    //     const leaderboardRes = await axios.get(
    //       `${this.baseUrl}/api/leaderboard/empiredrop`,
    //       { headers: { "x-api-key": process.env.VUE_APP_X_API_KEY } },
    //     );
    //     this.empiredropLeaderboard = leaderboardRes.data.leaderboard;
    //     this.empiredropNotFormattedStartDate = leaderboardRes.data.startDate;
    //     this.empiredropNotFormattedEndDate = leaderboardRes.data.endDate;
    //     this.startEmpiredropTimer();
    //   } catch (e) {
    //     console.warn("Failed to fetch EMPIREDROP leaderboard", e);
    //   }
    // },

    // startCsdropTimer() {
    //   let targetDate = this.getNextTargetDate(this.csdropNotFormattedEndDate);
    //   let timerInterval;
    //   this.updateTimer(this.csdropNotFormattedEndDate, "csdrop", targetDate, timerInterval);
    //   timerInterval = setInterval(
    //     () => this.updateTimer(this.csdropNotFormattedEndDate, "csdrop", targetDate, timerInterval),
    //     1000,
    //   );
    // },

    // startEmpiredropTimer() {
    //   let targetDate = this.getNextTargetDate(this.empiredropNotFormattedEndDate);
    //   let timerInterval;
    //   this.updateTimer(this.empiredropNotFormattedEndDate, "empiredrop", targetDate, timerInterval);
    //   timerInterval = setInterval(
    //     () => this.updateTimer(this.empiredropNotFormattedEndDate, "empiredrop", targetDate, timerInterval),
    //     1000,
    //   );
    // },
  },
  watch: {
    selectedLeaderboard() {
      switch (this.selectedLeaderboard) {
        case "stake":
          this.currentLeaderboard = this.stakeLeaderboard;
          this.currentLeaderboardCount = this.getStakePrizes().length;
          break;
        case "stakeonly":
          this.currentLeaderboard = this.stakeonlyLeaderboard;
          this.currentLeaderboardCount = this.getStakeOnlyPrizes().length;
          break;
        case "shuffle":
          this.currentLeaderboard = this.shuffleLeaderboard;
          this.currentLeaderboardCount = JSON.parse(
            `${process.env.VUE_APP_SHUFFLE_PRIZES_CURRENT}` || "[]",
          ).length;
          break;
        case "roobet":
          this.currentLeaderboard = this.roobetLeaderboard;
          this.currentLeaderboardCount = JSON.parse(
            `${process.env.VUE_APP_ROOBET_PRIZES_CURRENT}` || "[]",
          ).length;
          break;
        // case "skinrave":
        //   this.currentLeaderboard = this.skinraveLeaderboard;
        //   this.currentLeaderboardCount = JSON.parse(
        //     `${process.env.VUE_APP_SKINRAVE_PRIZES_CURRENT}` || "[]",
        //   ).length;
        //   break;
        case "casebattle":
          this.currentLeaderboard = this.casebattleLeaderboard;
          this.currentLeaderboardCount = JSON.parse(
            `${process.env.VUE_APP_CASEBATTLE_PRIZES_CURRENT}` || "[]",
          ).length;
          break;
        // case "packdraw":
        //   this.currentLeaderboard = this.packdrawLeaderboard;
        //   this.currentLeaderboardCount = JSON.parse(
        //     `${process.env.VUE_APP_PACKDRAW_PRIZES_CURRENT}` || "[]",
        //   ).length;
        //   break;
        // case 'raingg':
        //   this.currentLeaderboard = this.rainggLeaderboard;
        //   this.currentLeaderboardCount = JSON.parse(`${process.env.VUE_APP_RAINGG_PRIZES_CURRENT}` || "[]").length;
        //   break;
        // case 'csgold':
        //   this.currentLeaderboard = this.csgoldLeaderboard;
        //   this.currentLeaderboardCount = JSON.parse(`${process.env.VUE_APP_CSGOLD_PRIZES_CURRENT}` || "[]").length;
        //   break;
        // case "csdrop":
        //   this.currentLeaderboard = this.csdropLeaderboard;
        //   this.currentLeaderboardCount = JSON.parse(`${process.env.VUE_APP_CSDROP_PRIZES_CURRENT}` || "[]").length;
        //   break;
        // case "empiredrop":
        //   this.currentLeaderboard = this.empiredropLeaderboard;
        //   this.currentLeaderboardCount = JSON.parse(`${process.env.VUE_APP_EMPIREDROP_PRIZES_CURRENT}` || "[]").length;
        //   break;
      }
      this.animateCountUp();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
